import Monitor from '@fe/monitor';
import {
    getOrigin, getApiDomain, DOMAIN_LIST_API,
} from '@/config/env';
import { parseUrl } from '@/utils/url';

// 因为 Monitor Mini 包暂时不支持扩展对象，所以使用一下这种方式扩展
export const monitorTypes = {
    LAST_MARK: 0,
    PAGE_START: 1,
};

export const monitor = new Monitor();

export const init = () => {
    const env = (() => {
        const { env: spotEnv } = window.sfe;
        if (spotEnv === 'prd') {
            return 'mainnet';
        }
        if (spotEnv === 'testnet') {
            return 'testnet';
        }
        if (process.env.NODE_ENV === 'development') {
            return 'dev';
        }
        return 'sitnet';
    })();
    const traceWhiteList = DOMAIN_LIST_API.map((item) => `${getOrigin({ type: 'api', domain: item })}/`);

    monitor.init(
        {
            env,
            release: window.sfe.version,
            routeMode: 'history',
            traceWhiteList,
        },
        {
            v: '2.2',
            p: 'pc-spot',
        },
    );
    const metricsPlugin = {
        name: 'metrics',
        install({ report: { log, logOnce }, extend }) {
            const getPublicData = () => ({
                rt: getApiDomain(),
                ext: {
                    env: window.sfe.version,
                    href: window.location.href,
                },
            });
            const createGaugeFunction = (uploadFn) => (key, value, data = {}) => {
                if (value < 0 || typeof value !== 'number') {
                    return;
                }

                const publicData = getPublicData();
                uploadFn({
                    ...data,
                    ...publicData,
                    t: key,
                    d: value,
                    ext: {
                        ...(data.ext || {}),
                        ...publicData.ext,
                    },
                });
            };
            const gauge = createGaugeFunction(log);
            const gaugeOnce = createGaugeFunction(logOnce);
            const markCache = {};
            const getPageStartTime = () => {
                try {
                    return performance.timing.navigationStart;
                } catch (e) {
                    return 0;
                }
            };

            extend('counter', (key, data = {}) => {
                const publicData = getPublicData();

                return log({
                    ...data,
                    ...publicData,
                    t: key,
                    ext: {
                        ...(data.ext || {}),
                        ...publicData.ext,
                    },
                });
            });
            extend('gauge', gauge);
            extend('gaugeOnce', gaugeOnce);
            extend('mark', (key, type = monitorTypes.LAST_MARK) => {
                if (!key) return;
                if (type === monitorTypes.LAST_MARK) {
                    if (!markCache[key] || markCache[key].type !== 'mark') {
                        markCache[key] = {
                            type: 'mark',
                            last: Date.now(),
                        };
                    } else {
                        const value = Date.now() - markCache[key].last;
                        markCache[key].last = Date.now();
                        gauge(key, value);
                    }
                } else if (type === monitorTypes.PAGE_START) {
                    gauge(key, Date.now() - getPageStartTime());
                } else if (typeof type === 'object') {
                    // 设置分组初始化数据
                    if (!markCache[key] || markCache[key].type !== 'terms') {
                        if (!Array.isArray(type.terms) || !type.terms.length) return;
                        markCache[key] = {
                            type: 'terms',
                            terms: type.terms,
                            values: {},
                        };
                    }

                    // 标记单次的时长
                    if (type.name) markCache[key].values[type.name] = Date.now() - getPageStartTime();

                    // 计算是否完成了分组里所有标记，并上报最大、删除缓存
                    const { terms, values } = markCache[key];
                    // eslint-disable-next-line no-prototype-builtins
                    if (terms.every((name) => values.hasOwnProperty(name))) {
                        const data = terms.map((name) => values[name]);
                        const value = Math.max.apply(Math, data); // eslint-disable-line prefer-spread
                        gauge(key, value);
                        delete markCache[key];
                    }
                }
            });
        },
    };
    monitor.use(metricsPlugin);
};

export function reportError(res, msg) {
    if (!res.config || !res.config.url || navigator.onLine === false) return;
    const url = parseUrl(res.config.url);
    const value = Date.now() - res.config.requestTime;
    const ext = {};
    if (res.status) ext.hc = res.status;
    if (msg && typeof msg === 'string') ext.msg = msg.substr(0, 50); // 有错误信息时追加上去
    monitor.gaugeOnce('ajax', value, {
        r: url.pathname,
        ext,
    });
}

export function report(res) {
    const url = parseUrl(res.config.url);
    const value = Date.now() - res.config.requestTime;
    monitor.gauge('ajax', value, {
        r: url.pathname,
        ext: {
            code: res.data.ret_code || res.data.code || res.data.retCode || 0,
            hc: res.status || 200,
        },
    });
}

export function reportToken(msg, res) {
    if (res) {
        const url = parseUrl(res.config.url);
        monitor.counter('token_update', {
            r: url.pathname,
            ext: {
                msg,
                code: res.data.ret_code || res.data.code || res.data.retCode || 0,
                hc: res.status || 200,
            },
        });
    } else {
        monitor.counter('token_update', {
            ext: {
                msg,
            },
        });
    }
}
